import React from 'react';
import { EditDateInline } from './shared/EditDateInline';
import { OrderInformationSchemaGenerator } from '../../EditTransactionPrice/TransactionValidationSchema';
import { SmallBodyText } from '../../../../../ui-toolkit';
import { SummaryItemWithTooltip } from '../../../../shared/Summary/SummaryItem/SummaryItemWithTooltip';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export const FundingDate: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithTooltip
      label={`Funding Date`}
      tab={`summary`}
      data-test-id={'funding-date'}
      tooltip={EditDateInline}
      tooltipProps={{
        validationSchema: OrderInformationSchemaGenerator('fundingDate'),
        value: order.orderInformation.fundingDate,
        'data-test-id': 'funding-date',
        onUpdateOrder: async (value: string | null) => await onPatchOrderInformation({ fundingDate: value }),
        highlightDate: 'today',
      }}
    >
      {getDateString('LLLL d, yyyy', order.orderInformation.fundingDate) || (
        <SmallBodyText intent={'faded'}>Not Scheduled</SmallBodyText>
      )}
    </SummaryItemWithTooltip>
  );
};
